import { render, staticRenderFns } from "./Reboot.vue?vue&type=template&id=bd34f552"
import script from "./Reboot.vue?vue&type=script&lang=js"
export * from "./Reboot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports